<template>
  <li class="scrollitem">
    <b-button class="cat-btn" :id="categoryID" v-bind:class="activeCategory" v-on:click="selectCategory(category.id)">{{category.name}}</b-button>
	</li>
</template>
<script>
export default {
  name: 'Category',
  props: ['category', 'cat'],
  data () {
    return {
      isActive: true
    }
  },

  computed: {
    categoryID: function() {
      return "category_"+String(this.category.id);
    },

    activeCategory: function() {
        if (this.cat == this.category.id) {
          return { active: this.isActive }
        } else {
          return { active: false }
        }
    }
  },

  methods: {
    selectCategory(catid) {
      var sel = document.getElementById(this.categoryID);
      sel.scrollIntoView({behavior: "smooth", block: "nearest", inline: "center"});
      // Emit category id to parent
      this.$emit('catemit', catid, 1);
    }
  }
}
</script>

<style>

/* // Category header buttons */
.cat-btn {
  text-align: left;
  white-space: nowrap;
  /* min-width: 8rem; */
  width: auto;
  border: none !important;
  background-color: transparent !important;
	display:inline-block !important;
	cursor:pointer !important;
  color: #000;
  font-weight: bold;
	/* color:#fff !important; */
	/* font-family: Impact, Charcoal, sans-serif !important; */
	font-size:1rem !important;
  /* text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000 !important; */
}
.cat-btn:hover {
  color: #000 !important;
  background-color:transparent !important;
  /* text-shadow: none !important; */
}

.cat-btn.active {
  color: #fff !important;
  background-color: #000 !important;
  /* text-shadow: none !important; */
}

.scrollitem {
  scroll-snap-align: center;
  /* padding: calc(var(--gutter) / 2 * 1.5); */
  /* padding-left: 2rem; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  /* border-radius: 8px; */
}

@media (min-width: 768px) {
  .scrollitem {
    padding: calc(var(--gutter) / 2 * 1.5);
  }

  .cat-btn {
    font-size: 1.75rem !important;
    /* min-width: 12rem; */
  }
}

</style>
